import type {
    LabelControlLinkConstantType
} from "./type";

const LABEL_FIELD_SELECTOR = "input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"button\"]):not([type=\"submit\"]):not([type=\"reset\"]), textarea, select, [contenteditable=\"true\"]";

const LABEL_TOGGLE_SELECTOR = "[role=\"checkbox\"], [role=\"switch\"], [role=\"radio\"], [role=\"button\"], button, input";

export const getLabelControlElement = (htmlFor: string): HTMLElement | null => {
    if(typeof document === "undefined") {
        return null;
    }

    return document.getElementById(htmlFor);
};

export const getLabelControlField = (element: HTMLElement): HTMLElement | null => {
    if(element.matches(LABEL_FIELD_SELECTOR)) {
        return element;
    }

    if(element.matches(LABEL_TOGGLE_SELECTOR)) {
        return null;
    }

    return element.querySelector<HTMLElement>(LABEL_FIELD_SELECTOR);
};

export const activateLabelControl = (htmlFor: string): boolean => {
    const element = getLabelControlElement(htmlFor);

    if(!element) {
        return false;
    }

    if(element.matches(":disabled") || element.getAttribute("aria-disabled") === "true") {
        return true;
    }

    const field = getLabelControlField(element);

    if(field) {
        field.focus();

        return true;
    }

    element.focus({
        preventScroll: true
    });

    element.click();

    return true;
};

export const linkLabelControl = ({
    labelID,
    htmlFor
}: LabelControlLinkConstantType) => {
    const element = getLabelControlElement(htmlFor);

    if(!element || element.hasAttribute("aria-label") || element.hasAttribute("aria-labelledby")) {
        return undefined;
    }

    element.setAttribute("aria-labelledby", labelID);

    return () => {
        if(element.getAttribute("aria-labelledby") !== labelID) {
            return;
        }

        element.removeAttribute("aria-labelledby");
    };
};
